var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsights = function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "insights_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".insights_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5.5V23c0 .3.2.5.5.5h22.5",
    className: "insights_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 16.5h18c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H.5M.5 9.5h12c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H.5M.5 2.5h12c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H.5",
    className: "insights_svg__st0"
  })));
};
export default SvgInsights;